import Header from '../../components/base/Header';
import Footer from '../../components/base/Footer';

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-green-50 via-white to-green-50">
      <Header />
      
      <main className="container mx-auto px-4 py-12 max-w-4xl">
        <div className="bg-white rounded-lg shadow-lg p-8 md:p-12">
          <h1 className="text-3xl md:text-4xl font-bold text-green-800 mb-8 text-center">
            プライバシーポリシー
          </h1>

          <div className="prose prose-green max-w-none">
            <p className="text-gray-700 mb-8 leading-relaxed">
              ももちゃん畑（以下「当サイト」）では、個人情報の保護を重要な責務と考え、以下の通りプライバシーポリシーを定めます。
            </p>

            <section className="mb-10">
              <h2 className="text-2xl font-bold text-green-800 mb-4 flex items-center">
                <span className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center mr-3">
                  <span className="text-green-600 font-bold">1</span>
                </span>
                個人情報の利用目的
              </h2>
              <div className="bg-green-50 rounded-lg p-6 border-l-4 border-green-400">
                <p className="text-gray-700 leading-relaxed">
                  当サイトでは、お問い合わせフォームにていただいた個人情報を<br />
                  <strong className="text-green-700">「返信のため」のみに利用します。</strong>
                </p>
              </div>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl font-bold text-green-800 mb-4 flex items-center">
                <span className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center mr-3">
                  <span className="text-green-600 font-bold">2</span>
                </span>
                個人情報の第三者提供
              </h2>
              <div className="bg-green-50 rounded-lg p-6 border-l-4 border-green-400">
                <p className="text-gray-700 leading-relaxed">
                  法令に基づく場合を除き、個人情報を第三者へ提供することはありません。
                </p>
              </div>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl font-bold text-green-800 mb-4 flex items-center">
                <span className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center mr-3">
                  <span className="text-green-600 font-bold">3</span>
                </span>
                アクセス解析ツールについて
              </h2>
              <div className="bg-green-50 rounded-lg p-6 border-l-4 border-green-400">
                <p className="text-gray-700 leading-relaxed mb-3">
                  当サイトでは、Googleによるアクセス解析ツール「Google Analytics」を利用しています。
                </p>
                <p className="text-gray-700 leading-relaxed">
                  これはトラフィックデータの収集のために Cookie を使用しています。
                </p>
              </div>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl font-bold text-green-800 mb-4 flex items-center">
                <span className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center mr-3">
                  <span className="text-green-600 font-bold">4</span>
                </span>
                広告の配信について（Googleアドセンス用）
              </h2>
              <div className="bg-green-50 rounded-lg p-6 border-l-4 border-green-400">
                <p className="text-gray-700 leading-relaxed mb-3">
                  当サイトでは Google AdSense を利用予定です。
                </p>
                <p className="text-gray-700 leading-relaxed">
                  Google は Cookie を使用してユーザーの興味に応じた広告を表示します。
                </p>
              </div>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl font-bold text-green-800 mb-4 flex items-center">
                <span className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center mr-3">
                  <span className="text-green-600 font-bold">5</span>
                </span>
                免責事項
              </h2>
              <div className="bg-green-50 rounded-lg p-6 border-l-4 border-green-400">
                <p className="text-gray-700 leading-relaxed">
                  当サイトに掲載している情報は、できる限り正確なものを提供するよう努めていますが、<br />
                  その正確性や安全性を保証するものではありません。
                </p>
              </div>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl font-bold text-green-800 mb-4 flex items-center">
                <span className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center mr-3">
                  <span className="text-green-600 font-bold">6</span>
                </span>
                著作権について
              </h2>
              <div className="bg-green-50 rounded-lg p-6 border-l-4 border-green-400">
                <p className="text-gray-700 leading-relaxed mb-3">
                  当サイトに掲載されている画像・イラスト・文章の著作権は、当サイトに帰属します。
                </p>
                <p className="text-gray-700 leading-relaxed">
                  <strong className="text-green-700">無断転載を禁止します。</strong>
                </p>
              </div>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl font-bold text-green-800 mb-4 flex items-center">
                <span className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center mr-3">
                  <span className="text-green-600 font-bold">7</span>
                </span>
                プライバシーポリシーの変更
              </h2>
              <div className="bg-green-50 rounded-lg p-6 border-l-4 border-green-400">
                <p className="text-gray-700 leading-relaxed">
                  本ポリシーは予告なく変更される場合があります。
                </p>
              </div>
            </section>

            <div className="mt-12 pt-8 border-t border-green-200 text-center">
              <p className="text-gray-600 text-sm">
                最終更新日：{new Date().toLocaleDateString('ja-JP', { year: 'numeric', month: 'long', day: 'numeric' })}
              </p>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
